import React from "react";
import { Box, Card, CardContent, Grid, Skeleton } from "@mui/material";

const KPICardSkeleton: React.FC = () => (
  <Card
    variant="outlined"
    sx={{ borderRadius: 3, height: "100%" }}
  >
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width={100} height={18} />
          <Skeleton variant="rounded" width={80} height={36} sx={{ mt: 0.5 }} />
        </Box>
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
    </CardContent>
  </Card>
);

const ChartSkeleton: React.FC<{ height?: number }> = ({ height = 280 }) => (
  <Card
    variant="outlined"
    sx={{ borderRadius: 3, height: "100%" }}
  >
    <CardContent>
      <Skeleton variant="text" width={160} height={24} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width="100%" height={height - 60} />
    </CardContent>
  </Card>
);

export const AnalyticsSkeleton: React.FC = () => (
  <>
    {/* KPI cards */}
    <Grid container spacing={2} sx={{ mb: 3, alignItems: "stretch" }}>
      {Array.from({ length: 6 }).map((_, i) => (
        <Grid key={i} size={{ xs: 12, sm: 6, md: 4 }}>
          <KPICardSkeleton />
        </Grid>
      ))}
    </Grid>

    {/* Charts row 1 */}
    <Grid container spacing={2} sx={{ mb: 2, alignItems: "stretch" }}>
      <Grid size={{ xs: 12, md: 8 }}>
        <ChartSkeleton height={280} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <ChartSkeleton height={280} />
      </Grid>
    </Grid>

    {/* Charts row 2 */}
    <Grid container spacing={2} sx={{ mb: 2, alignItems: "stretch" }}>
      <Grid size={{ xs: 12, md: 4 }}>
        <ChartSkeleton height={280} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <ChartSkeleton height={280} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <ChartSkeleton height={280} />
      </Grid>
    </Grid>

    {/* Charts row 3 */}
    <Grid container spacing={2} sx={{ mb: 2, alignItems: "stretch" }}>
      <Grid size={{ xs: 12, md: 4 }}>
        <ChartSkeleton height={280} />
      </Grid>
    </Grid>
  </>
);
